import React, {useState, useEffect} from 'react'
import {Line} from 'react-chartjs-2'
import {fetchCases} from '../api/index'

const formatDate = (myDate) => {
  return new Date(myDate).toDateString()
}

function DataChart({Country}) {
  const [dailyData, setDailyData] = useState([])
  const [netError, setNetError] = useState()
  useEffect(() => {
    fetchCases(Country)
      .then((response) => {
        setDailyData(response.data)
      })
      .catch((error) => {
        setNetError(setNetError)
        setDailyData([])
      })
  }, [Country])
  console.log(Country)

  return (
    <div>
      <div>
        {dailyData ? (
          <Line
            width={100}
            height={500}
            options={{
              maintainAspectRatio: false,
              legend: {
                display: true,
                labels: {
                  fontColor: 'rgb(255,255,255)',
                },
              },
              title: {
                display: true,
                text: `Chart for ${Country}`,
                position: 'top',
                padding: 10,
                fontColor: '#ffffff',
                fontSize: 20,
              },
              animation: {
                easing: 'easeInCubic',
              },
            }}
            responsive={true}
            data={{
              labels: dailyData.map(({Date}) => formatDate(Date)),
              datasets: [
                {
                  data: dailyData.map(({Confirmed}) => Confirmed),
                  label: 'Confirmed',
                  borderColor: 'rgb(255,0,0)',
                  fill: true,
                  pointRadius: 0,
                },
                {
                  data: dailyData.map(({Active}) => Active),
                  label: 'Active',
                  borderColor: 'rgba(74, 127, 180, 0.7)',
                  fill: true,
                  pointRadius: 0,
                },
                {
                  data: dailyData.map(({Recovered}) => Recovered),
                  label: 'Recovered',
                  borderColor: 'rgb(0,255,0)',
                  fill: true,
                  pointRadius: 0,
                },
                {
                  data: dailyData.map(({Deaths}) => Deaths),
                  label: 'Deaths',
                  borderColor: 'rgb(255,255,255,0.5)',
                  fill: true,
                  pointRadius: 0,
                },
              ],
            }}
          />
        ) : (
          <div className="text-danger">
            <h1>/{netError}</h1>
          </div>
        )}
      </div>
    </div>
  )
}

export default DataChart
